// Desactivar SSR y prerender globalmente para adapter-static con fallback SPA
export const ssr = false;
export const prerender = false;
